const LoadingIndicatorLargeCenter: React.FC = () => {
  return (
    <div className="center-absolute">
      <div className="spinner-border text-primary" role="status" />
    </div>
  );
};

export default LoadingIndicatorLargeCenter;
